window.submoduleBrunchNames = {
  [OPUtility.eSubmoduleNames.ESN_OP_WRAPPER_SERVICE]: 'master',
  [OPUtility.eSubmoduleNames.ESN_GAME_ENGINE]: 'main2',
  [OPUtility.eSubmoduleNames.ESN_OP_PRELOADER]: 'master'
}
